import {MapSite} from "../../entities/MapSite";
import {MapArea} from "../../entities/MapArea";
import {Reader} from "../../entities/Reader";
import {Asset} from "../../entities/Asset";
import {FixedVTag} from "../../entities/FixedVTag";
import {MapSiteService} from "../../services/MapSiteService";
import {MapAreaService} from "../../services/MapAreaService";
import {AssetService} from "../../services/AssetService";
import {FixedVTagService} from "../../services/FixedVTagService";
import {NotificationService} from "../../services/NotificationService";
import {ReaderService} from "../../services/ReaderService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {FileDataService} from "../../services/FileDataService";
import {IVTag} from "../../entities/IVTag";

export class CmdCenterMapModel {
    static $inject = ['$q','MapSiteService','MapAreaService','AssetService','FixedVTagService','NotificationService','ReaderService','CustomFieldNameService','ApplicationSettingService','FileDataService'];
    pageSize:number = 200;
    currentPage:number = 1;
    selectedItems:any[] = [];
    mapSites:MapSite[];
    selectedMapSite:MapSite;
    mapAreas:MapArea[];
    currentMapAreas:MapArea[];
    selectedMapArea:MapArea;
    gateways:Reader[];
    assets:Asset[];
    fixedTags:FixedVTag[];
    currentFixedTags:FixedVTag[];
    currentAssets:Asset[];
    currentGateways:Reader[];
    vTagPositionReportingMode:string;
    searchText:string = "";
    rawSearchText:string = "";
    siteByGateway:any;
    assetColumnDefs:[string,string,number][];
    vtagColumnDefs:[string,string,number][];
    lastCheckedChanged:Date;
    customFieldNames:any[];
    imageData:string;
    mapRefresh:number = 10;
    activeTimeout:number = 90;
    //activeLimitMinutes:number = 60;
    constructor(public $q:ng.IQService,
                public mapSiteService:MapSiteService,
                public mapAreaService:MapAreaService,
                public assetService:AssetService,
                public fixedTagService:FixedVTagService,
                public notificationService:NotificationService,
                public readerService:ReaderService,
                public customFieldNameService:CustomFieldNameService,
                public applicationSettingService:ApplicationSettingService,
                public fileDataService:FileDataService){
        // console.log("mapmodel ctr");
        this.lastCheckedChanged = new Date();
    }
    init(lastSiteId:number, lastAreaId:number):ng.IPromise<any>{
        // console.log("INITING!!!")
        this.selectedItems = [];
        return this.$q.all([
            this.mapSiteService.getAll(),
            this.mapAreaService.getAll(),
            this.readerService.getGateways(),
            this.customFieldNameService.getAssetColumnDefs(),
            this.customFieldNameService.getVTagColumnDefs(),
            this.applicationSettingService.getCached()
        ])
            .then( (data:any)=> {
                // console.log("INITING2!!!")
                this.mapSites = data[0];
                this.mapAreas = data[1];
                this.gateways = data[2];
                this.assetColumnDefs = data[3];
                this.vtagColumnDefs = data[4];
                this.mapRefresh = data[5].cmdMapRefresh;
                this.activeTimeout = data[5].cmdActiveTimeout;
                this.vTagPositionReportingMode = data[5].vTagPositionReportingMode;

                this.siteByGateway = {};
                for(var i=0;i<this.gateways.length;i++){
                    this.siteByGateway[this.gateways[i].id] = this.gateways[i].mapSiteID;
                }
                if(lastSiteId != null){
                    for(var i=0;i<this.mapSites.length; i++){
                        var mapSite  = this.mapSites[i];
                        if(mapSite.id == lastSiteId){
                            this.selectedMapSite = mapSite;
                            break;
                        }
                    }
                }
                // Modified 04/24/19 by BA to handle no match for lastSiteId
                if(this.selectedMapSite == null && this.mapSites.length > 0) {
                    this.selectedMapSite = this.mapSites[0];
                }
                // console.log("about getAssets");
                this.setMapAreas(lastAreaId);
                if(this.selectedMapArea == null)
                  return this.$q.when<boolean>(false);
                return this.$q.all([this.getAssets(), this.getFixedTags()]).then((data)=>{
                  this.getCurrentTags();
                  return this.$q.when<boolean>(data[0] && data[1]);
                });
            })
            .catch((data:any)=>{
                var error = data;
                //handle error
                alert("handle error "+data);
            });
    }
    getMapAreaImage():ng.IPromise<boolean>{
      return this.fileDataService.get(this.selectedMapArea.fileDataID).then((b64Data)=>{
        this.imageData = b64Data;
        return this.$q.when<boolean>(true);
      });
    }
    getChangedAssets(lastCheckedChanged:string):ng.IPromise<void>{
        if(this.selectedMapSite == null)
          return this.$q.when();
        return this.assetService.getChangedVTagAndGpsAssetsBySite(this.selectedMapSite.id, lastCheckedChanged).then((assets)=>{
            //var assets:Asset[] = Asset.parseJsonArr(data);
            $.each(assets, (i,asset:Asset)=>{
                var found:boolean = false;
                for(var j:number=0;j<this.assets.length;j++){
                    var currAsset = this.assets[j];
                    if(currAsset.id === asset.id){
                        this.assets[j] = asset;
                        found = true;
                    }
                }
                if(!found)
                  this.assets.push(asset);
                found = false;
                for(var j:number=0;j<this.currentAssets.length;j++){
                    var currAsset = this.currentAssets[j];
                    //if found in current (update), update it.
                    if(currAsset.id === asset.id){
                        this.currentAssets[j] = asset;
                        found = true;
                    }
                }
                //if not found in current and should be shown (new), add it.
                if(!found && this.getIsAssetShown(asset)){
                  this.currentAssets.push(asset);
                }
            })
            return this.$q.when();
        });
    }
    getChangedFixedTags(lastCheckedChanged:string):ng.IPromise<void>{
        if(this.selectedMapSite == null)
            return this.$q.when();
        return this.fixedTagService.getChangedBySite(this.selectedMapSite.id, lastCheckedChanged).then((fixedTags)=>{
            var changedCurrFixed:FixedVTag[] = [];
            $.each(fixedTags, (i,fixedTag:FixedVTag)=>{
                var found:boolean = false;
                for(var j:number=0;j<this.fixedTags.length;j++){
                    var currFixed = this.fixedTags[j];
                    if(currFixed.id === fixedTag.id){
                        this.fixedTags[j] = fixedTag;
                        found = true;
                    }
                }
                if(!found)
                    this.fixedTags.push(fixedTag);
                found = false;
                for(var j:number=0;j<this.currentFixedTags.length;j++){
                    var currFixedTag = this.currentFixedTags[j];
                    //if found in current (update), update it.
                    if(currFixedTag.id === fixedTag.id){
                        this.currentFixedTags[j] = fixedTag;
                        changedCurrFixed.push(fixedTag);
                        found = true;
                    }
                }
                //if not found in current and should be shown (new), add it.
                if(!found && this.getIsFixedTagShown(fixedTag)){
                    this.currentFixedTags.push(fixedTag);
                    changedCurrFixed.push(fixedTag);
                }
            })
            return this.$q.when();
        });
    }
    getChangedGateways(lastCheckedChanged:string):ng.IPromise<void>{
        if(this.selectedMapSite == null)
            return this.$q.when();
        return this.readerService.getChangedBySite(this.selectedMapSite.id, lastCheckedChanged).then((gateways)=>{
            var changedCurrGateways:Reader[] = [];
            $.each(gateways, (i,gateway:Reader)=>{
                var found:boolean = false;
                for(var j:number=0;j<this.gateways.length;j++){
                    var currGateway = this.gateways[j];
                    if(currGateway.id === gateway.id){
                        this.gateways[j] = gateway;
                        found = true;
                    }
                }
                if(!found)
                    this.gateways.push(gateway);
                found = false;
                for(var j:number=0;j<this.currentGateways.length;j++){
                    var currGateway = this.currentGateways[j];
                    //if found in current (update), update it.
                    if(currGateway.id === gateway.id){
                        this.currentGateways[j] = gateway;
                        changedCurrGateways.push(gateway);
                        found = true;
                    }
                }
                //if not found in current and should be shown (new), add it.
                if(!found && this.getIsGatewayShown(gateway)){
                    this.currentGateways.push(gateway);
                    changedCurrGateways.push(gateway);
                }
            })
            return this.$q.when();
        });
    }
    setMapAreas(defaultMapAreaId?:number){
        var temp:MapArea[] = [];
        for(var i=0;i<this.mapAreas.length;i++){
            if(this.mapAreas[i].mapSiteID === this.selectedMapSite.id)
                temp.push(this.mapAreas[i]);
        }
        this.currentMapAreas = temp;
        if (this.currentMapAreas.length == 0)
            return;
        var newMapArea: MapArea = this.currentMapAreas[0];
        if(defaultMapAreaId != null){
            for(var i=0; i<this.currentMapAreas.length; i++){
                var mapArea = this.currentMapAreas[i];
                if (mapArea.id == defaultMapAreaId) {
                    newMapArea = mapArea;
                    break;
                }
            }
        }
        this.selectedMapArea = newMapArea;
        // Modified 04/24/19 by BA to handle no match for map area
        //if(this.selectedMapArea == null && this.currentMapAreas.length > 0) {
        //    this.selectedMapArea = this.currentMapAreas[0];
        //}
    }
    getAssets(){
        // console.log("getAssets");
        if(this.selectedMapSite == null) {
          this.assets = [];
          return this.$q.when<boolean>(false);
        }
        return this.assetService.getVTagAndGpsAssetsBySite(this.selectedMapSite.id).then((assets)=>{
            this.assets = assets;
            // console.log("getAssets len="+this.assets.length);
            return this.$q.when<boolean>(true);
        })
    }
    getFixedTags():ng.IPromise<boolean>{
        // console.log("getFixedTags");
        if(this.selectedMapSite == null) {
            this.fixedTags = [];
            return this.$q.when<boolean>(false);
        }
        return this.fixedTagService.getBySite(this.selectedMapSite.id).then((tags)=>{
            this.fixedTags = tags;
            // console.log("getFixedTags len="+this.fixedTags.length);
            return this.$q.when<boolean>(true);
        })
    }
    getGateways():ng.IPromise<boolean>{
        if(this.selectedMapSite == null) {
            this.gateways = [];
            return this.$q.when<boolean>(false);
        }
        return this.readerService.getBySite(this.selectedMapSite.id).then((gateways)=>{
            this.gateways = gateways;
            // console.log("getFixedTags len="+this.fixedTags.length);
            return this.$q.when<boolean>(true);
        })
    }
    locateAdv():ng.IPromise<IVTag>{
      //first try to find a match of asset
      var vtagPromise:ng.IPromise<IVTag>;
      var foundInCurrent:boolean = false;
      if(this.currentFixedTags.length > 0){
        //first see if there is an exact match in current fixed assets
        vtagPromise = this.$q.when<IVTag>(this.currentFixedTags[0]);
        foundInCurrent = true;
      }
      else if(this.currentAssets.length > 0){
        //next see if there are any matches in currentAssets
        vtagPromise = this.$q.when<IVTag>(this.currentAssets[0]);
        foundInCurrent = true;
      }
      else{
        var foundInFixed:boolean = false;
        //next check if there are any matches in all fixedVTags
        for(var i=0;i<this.fixedTags.length;i++){
          if(this.fixedTags[i].search(this.searchText)){
            // console.log("found tag in full fixed tag list");
            vtagPromise = this.$q.when<IVTag>(this.fixedTags[i]);
            foundInFixed = true;
            break;
          }
        }
        //next see if there are any matches in all asset tags
        for(var i=0;i<this.assets.length;i++&&!foundInFixed){
          if(this.assets[i].search(this.searchText)){
            // console.log("found tag in full asset list");
            vtagPromise = this.$q.when<IVTag>(this.assets[i]);
            break;
          }
        }
      }
      if(vtagPromise == null){
        //still nothing? Query the database for either an asset or a fixedvtag that matches the searchText
        vtagPromise = this.$q.all([
          this.assetService.getFirstVTagAndGpsMatch(this.searchText),this.fixedTagService.getFirstVTagMatch(this.searchText)])
          .then((data)=>{
            var foundAsset:Asset = data[0];
            var foundFixed:FixedVTag = data[1];
            if(foundFixed != null){
              return this.$q.when<IVTag>(foundFixed);
            }
            else if(foundAsset != null){
              return this.$q.when<IVTag>(foundAsset);
            }
            else
              return this.$q.when<IVTag>(null);
          });
      }
      return vtagPromise.then((vtag)=>{
        // match the mapsite and maparea with the asset that was found.
        // console.log("found in current1="+foundInCurrent+" and tag null?"+(vtag == null));
        if(vtag == null){
          this.notificationService.notify("V-Tag not found that matches search text "+this.searchText);
          return this.$q.when<IVTag>(null);
        }
        if(!foundInCurrent){
          var foundMapSiteId:number = this.siteByGateway[vtag.readerID];
          var foundMapSite = null;
          for(var i=0;i<this.mapSites.length; i++){
              var val = this.mapSites[i];
              if(val.id==foundMapSiteId){
                  foundMapSite = val;
                  break;
              }
          }
          if(foundMapSite != null && foundMapSite != this.selectedMapSite){
            // console.log("found site = "+foundMapSite.name);
            this.selectedMapSite = foundMapSite;
          }
          this.setMapAreas();
          //find which maparea matches the floor #
            for(var i=0;i<this.currentMapAreas.length; i++){
                var tempMapArea = this.currentMapAreas[i];
                if(tempMapArea.floorLevel == vtag.vTagZ) {
                    this.selectedMapArea = tempMapArea;
                    return this.$q.when<IVTag>(vtag);
                }
            }
        }
        return this.$q.when<IVTag>(vtag);
      });
    }
    getIsAssetShown(asset:Asset):boolean{
      var areaMatch:boolean = asset.vTagZ === this.selectedMapArea.floorLevel || asset.vTagZ === null;
      var searchMatch:boolean = asset.search(this.searchText);
      // console.log("name="+curr.name+" and search match="+searchMatch);
      var isActive = asset.isActiveTag(this.activeTimeout);
      var filtered = false;
      switch(this.selectedFilter){
        case this.SHOWACTIVEASSETS:
        case this.SHOWACTIVETAGS:
          filtered = isActive;
          break;
        case this.SHOWINACTIVEASSETS:
        case this.SHOWINACTIVETAGS:
          filtered = !isActive;
          break;
        case this.SHOWALLASSETS:
        case this.SHOWALLTAGS:
          filtered = true;
          break;
      }
      return areaMatch && searchMatch && filtered;
    }
    getIsFixedTagShown(fixedTag:FixedVTag):boolean{
        var areaMatch:boolean = fixedTag.vTagZ === this.selectedMapArea.floorLevel || fixedTag.vTagZ === null;
        var searchMatch:boolean = fixedTag.search(this.searchText);
        // console.log("name="+curr.name+" and search match="+searchMatch);
        var isActive = fixedTag.isActiveTag(this.activeTimeout);
        var filtered = false;
        switch(this.selectedFilter){
            case this.SHOWACTIVEFIXED:
            case this.SHOWACTIVETAGS:
                filtered = isActive;
                break;
            case this.SHOWINACTIVEFIXED:
            case this.SHOWINACTIVETAGS:
                filtered = !isActive;
                break;
            case this.SHOWALLFIXED:
            case this.SHOWALLTAGS:
                filtered = true;
                break;

        }
        return areaMatch && searchMatch && filtered
    }
    getIsGatewayShown(gateway:Reader):boolean{
        var areaMatch:boolean = gateway.vTagZ === this.selectedMapArea.floorLevel || gateway.vTagZ === null;
        var searchMatch:boolean = gateway.search(this.searchText);
        // console.log("name="+curr.name+" and search match="+searchMatch);
        var isActive = gateway.isActive(this.activeTimeout);
        var filtered = false;
        switch(this.selectedFilter){
            case this.SHOWACTIVEFIXED:
            case this.SHOWACTIVETAGS:
                filtered = isActive;
                break;
            case this.SHOWINACTIVEFIXED:
            case this.SHOWINACTIVETAGS:
                filtered = !isActive;
                break;
            case this.SHOWALLFIXED:
            case this.SHOWALLTAGS:
                filtered = true;
                break;

        }
        return areaMatch && searchMatch && filtered
    }
    getCurrentTags(){
        //filter by selectedMapArea, searchText, selectedFilter
        var tempAssets:Asset[] = [];
        // console.log("getCurrAssets. len="+this.assets.length);
        for(var i=0;i<this.assets.length;i++){
            var currentAsset = this.assets[i];
          var show = this.getIsAssetShown(currentAsset);
            if(show)
                tempAssets.push(currentAsset);
        }
        this.currentAssets = tempAssets;
        var tempFixed:FixedVTag[] = [];
        for(var i=0;i<this.fixedTags.length;i++){
            var currentFixed = this.fixedTags[i];
            var show = this.getIsFixedTagShown(currentFixed);
            if(show)
                tempFixed.push(currentFixed);
        }
        this.currentFixedTags = tempFixed;
        var tempGateways:Reader[] = [];
        for(var i=0;i<this.gateways.length;i++){
            var currentGateway = this.gateways[i];
            var show = this.getIsGatewayShown(currentGateway);
            if(show)
                tempGateways.push(currentGateway);
        }
        this.currentGateways = tempGateways;
    }
    addSelected(item:any):void{
        var foundIndex = this.selectedItems.indexOf(item);
        if(foundIndex != -1)
            this.selectedItems[foundIndex] = item;
        else
            this.selectedItems.push(item);
        //this.selectionChanged();
    }
    removeSelected(item:any):void{
        var foundIndex = this.selectedItems.indexOf(item);
        if(foundIndex != -1)
            this.selectedItems.splice(foundIndex,1);
        //this.selectionChanged();
    }
    runCommand(){

    }
    getBaseUrl():string{
        return this.fileDataService.getBaseUrl();
    }
    CMDGETPOSITION="Get Position";
    CMDSETPOSITIONFIXED="Set Position Fixed";
    CMDSETPOSITIONGATEWAY="Set Position Gateway";
    CMDACTIVATE="Activate";
    CMDRESETTAG="Reset Tag";
    CMDBUZZ = "Buzz";
    commands:string[] = [this.CMDGETPOSITION,this.CMDSETPOSITIONFIXED,this.CMDSETPOSITIONGATEWAY,this.CMDACTIVATE,this.CMDRESETTAG,this.CMDBUZZ];
    selectedCommand = this.CMDGETPOSITION;
    SHOWALLTAGS:string = "Show All";
    SHOWACTIVETAGS:string = "Show All Active";
    SHOWINACTIVETAGS:string = "Show All Inactive";
    SHOWALLASSETS:string = "Show All Assets";
    SHOWACTIVEASSETS:string = "Show Active Assets";
    SHOWINACTIVEASSETS:string = "Show Inactive Assets";
    SHOWALLFIXED:string = "Show All Fixed or Gateway";
    SHOWACTIVEFIXED:string = "Show Active Fixed or Gateway";
    SHOWINACTIVEFIXED:string = "Show Inactive Fixed or Gateway";
    filterTypes:string[] = [this.SHOWALLTAGS,this.SHOWACTIVETAGS,this.SHOWINACTIVETAGS,this.SHOWALLASSETS,this.SHOWACTIVEASSETS,this.SHOWINACTIVEASSETS,this.SHOWALLFIXED,this.SHOWACTIVEFIXED,this.SHOWINACTIVEFIXED];
    selectedFilter:string = this.SHOWALLASSETS;
}
